<template>
  <AppShell
    :routes="mainRoutes"
    home-path="/"
    :full-name="fullName"
    @logout="logout"
  />
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRouter } from "vue-router";
import AppShell, { type ShellRoute } from "@/components/layout/AppShell.vue";
import { useAuthService } from "@/services/authService";
import { useAuthStore } from "@/store/AuthStore";

const router = useRouter();
const { logout: authLogout } = useAuthService();
const authStore = useAuthStore();
const fullName = computed(() => authStore.fullName);

const mainRoutes = computed<ShellRoute[]>(() => {
  const routes: ShellRoute[] = [
    { path: "/", name: "Kezdőlap", icon: "mdi-view-dashboard-outline" },
    {
      path: "/accommodationinquiries",
      name: "Szállás igények",
      icon: "mdi-message-text-outline",
    },
    {
      path: "/bookings",
      name: "Foglalások",
      icon: "mdi-calendar-check-outline",
    },
    {
      path: "/costcenters",
      name: "Költséghelyek",
      icon: "mdi-office-building-outline",
    },
  ];
  if (authStore.isCompanyAdmin) {
    routes.push({
      path: "/users",
      name: "Felhasználók",
      icon: "mdi-account-multiple-outline",
    });
  }
  return routes;
});

async function logout() {
  await authLogout();
  router.push("/login");
}
</script>
